import * as yup from "yup";
import {withFormik} from "formik";
import {isNotEmpty} from "../../../helpers/functions";
import httpClient from "../../../services/httpClient";
import {ticketsApi} from "../../../constans/apiUrls";
import {ITicketReplayFormData} from "../../../contracts/data/ticket";
import InnerReplyTicketForm from "../../../components/FormTemplates/ticket/InnerReplyTicketForm";

const replyTicketFormValidationSchema = yup.object().shape({
    content: yup.string().required("متن پاسخ تیکت الزامی میباشد"),
})

interface IReplyTicketFormProps {
    ticketId: number,
    handlerInsertReply: any
}

const ReplyTicketForm = withFormik<IReplyTicketFormProps, ITicketReplayFormData>({
    validationSchema: replyTicketFormValidationSchema,
    handleSubmit: async (values, formikBag) => {
        const formData = new FormData();
        if (values.attachment && isNotEmpty(values.attachment) && typeof values.attachment === 'object') {
            formData.append('attachment', values.attachment)
        }

        formData.append('data', JSON.stringify(values));
        await httpClient().put(`${ticketsApi.update}/${formikBag?.props?.ticketId}`, formData)
            .then(response => {
                if(response.status === 201 || response.status === 200 ){
                    formikBag?.props?.handlerInsertReply(response?.data?.data)
                    formikBag.setStatus({
                        ...formikBag.props,
                        result: response.data
                    })
                }
            })
            .catch(error => console.log(error))
    },
    displayName: 'ReplyTicketForm'
})(InnerReplyTicketForm)

export default ReplyTicketForm